import {memo, useEffect} from "react"
import dynamic from 'next/dynamic'
import Aos from 'aos'
import 'aos/dist/aos.css'

const IslToken = dynamic(() => import('./components/IslToken'))
const TokenEconomy = dynamic(() => import('./components/tokenEconomy'))
const TokenDistribution = dynamic(() => import('./components/tokenDistribution'))
const Play = dynamic(() => import("./components/Play"))

const TokenContent = () => {
	useEffect(() => {
		Aos.init()
	}, [])

	return (
		<>
			<Play/>
			<IslToken/>
			<TokenEconomy/>
			<TokenDistribution/>
		</>
	)
}

export default memo(TokenContent)
